import { createFileRoute } from '@tanstack/react-router';

import { RoomListPage } from '~pages/rooms/room-list-page';

export const Route = createFileRoute('/_auth/_layout/category-config/rooms')({
  component: RoomListPage,
});
